import {DtoMediaInfoInterface, MediaInfoModel} from "../interfaces";

export const mapMediaInfoFromDto = (dto: DtoMediaInfoInterface): MediaInfoModel => {
  return {
    name: dto.name ?? "",
    size: dto.size,
    metadata: dto.metadata,
    tags: dto.tags,
    lastModifiedUtc: dto.lastModifiedUtc ?? new Date(NaN),
    url: dto.url ?? "",
    relatedType: dto.relatedType
  };
};

export const mapMediaInfoFromDtoArray = (array: Array<DtoMediaInfoInterface>): Array<MediaInfoModel> => {
  const result: Array<MediaInfoModel> = [];

  array.forEach(dto => {
    result.push(mapMediaInfoFromDto(dto));
  });

  return result;
};
